module.exports = __webpack_public_path__ + "static/media/gb-sct.ade55ed4.svg";